module.exports = __webpack_public_path__ + "img/BackArrow.7dea2df0.svg";